import React, { useCallback, useEffect, useState } from 'react';
import { CustomImage, CustomModal, errorDialog, Text, useText } from '@src/components';
import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  finishPaymentProcess,
  processPayment,
  setCreditCardMatchVous,
  setSelectStoredCard,
} from '@src/store/slice/mobilExpressSlice';
import modalClose from '@src/assets/icons/icon-close.svg';
import PayWithNewCard from '@src/pages/ticketRestaurant/paymentModals/payWithNewCard/payWithNewCard';
import iconBack from '@src/assets/icons/icon-back.svg';
import { createFleetLoadBalanceSuccess } from '@src/store/slice/addFleetLimitStore/addFleetLimitSlice';
import PropTypes from 'prop-types';
import '@src/styles/vehicleManagement/vehicleManagement.scss';

let paymentOrderDueDate = null;
let _selectedStoredCard = null;

const OrderSummary = ({ form, formVisible, paymentValue, setIsOrderSuccess, goBackPayment }) => {
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const { fleetLoadBalanceId } = useSelector((state) => state.addFleetLimit);
  const { selectedStoredCard, payWithLinkinEmail } = useSelector((state) => state?.mobilExpress);
  const [threeDSecureContent, setThreeDSecureContent] = useState('');
  const [saveCardBody, setSaveCardBody] = useState({ body: {}, checked: false });
  const dispatch = useDispatch();
  const [isOrderFinishSuccess, setIsOrderFinishSuccess] = useState(false);
  const [modals, setModals] = useState({
    threeDSecureModalVisible: false,
    instantRemittanceModalVisible: false,
    payWithNewCard: false,
  });
  const afterMount = false;
  const modalAction = (prop, value) => {
    setModals((modals) => ({
      ...modals,
      [prop]: value,
    }));
  };
  const customerId = selectedCustomer?.customerId;
  const [payWhenBalanceActiveDate, setPayWhenBalanceActiveDate] = useState(false);

  const threeDSecurity = useText('3dSecurity');

  const paymentLater = async () => {
    modalAction('payWithNewCard', false);
    await finishOrder();
  };

  useEffect(() => {
    _selectedStoredCard = selectedStoredCard;
  }, [selectedStoredCard]);

  useEffect(() => {
    console.log('OrderSummary');
  }, [isOrderFinishSuccess]);

  const finishOrder = async (action = null) => {
    if (formVisible) {
      const formData = await form.getFieldsValue();
      const cardBin = formData.cardNumber?.replaceAll('-', '')?.slice(0, 6) || '';
      const orderRes = await dispatch(
        createFleetLoadBalanceSuccess({
          data: {
            id: fleetLoadBalanceId,

            customerId: customerId,

            mobilExpressMerchantProcessId: action?.payload?.data?.processInfo?.merchantProcessId,

            mobilExpressOrderId: action?.payload?.data?.paymentInfo?.orderId,

            mobilExpressSystemTransId: action?.payload?.data?.paymentInfo?.systemTransId,

            mobilExpressIsPayment: 0,

            paymentType: 4,

            paymentLater: false,

            cardBin: cardBin,

            pendingApproval: false,

            sendMail: true,

            orderStatus: 100,
            vouId: 4,
          },
        }),
      );
      if (orderRes?.payload?.isSuccess) {
        setIsOrderFinishSuccess(true);

        modalAction('threeDSecureModalVisible', false);
        setTimeout(() => {
          setIsOrderSuccess(true);
        }, 500);
      }
      await form.resetFields();
    } else {
      if (!isOrderFinishSuccess) {
        const orderRes = await dispatch(
          createFleetLoadBalanceSuccess({
            data: {
              id: fleetLoadBalanceId,

              customerId: customerId,

              mobilExpressMerchantProcessId: action?.payload?.data?.processInfo?.merchantProcessId,

              mobilExpressOrderId: action?.payload?.data?.paymentInfo?.orderId,

              mobilExpressSystemTransId: action?.payload?.data?.paymentInfo?.systemTransId,

              mobilExpressIsPayment: 0,

              paymentType: 4,
              vouId: 4,

              paymentLater: false,

              cardBin: null,

              pendingApproval: false,

              sendMail: true,

              orderStatus: 100,
            },
          }),
        );
        if (orderRes?.payload?.isSuccess) {
          setIsOrderSuccess(true);
        }
      }
    }
    if (isOrderFinishSuccess) setIsOrderFinishSuccess(false);
    //setIsOrderSuccess(true);
    //await dispatch(cardOrdersUpdate(body));
  };

  useEffect(() => {
    window.paymentLater = paymentLater;
    return () => {
      window.paymentLater = () => {};
    };
  }, [paymentLater]);

  const saveNewCardWithParam = async (isDump) => {
    const values = await form.validateFields();
    const { cardHolderName, cardNumber, lastMonth, lastYear } = values;
    const body = {
      body: {
        currency: 'TRY',
        paymentInstrument: 'NewCard',
        paymentInstrumentInfo: {
          newCard: {
            processType: 'sales',
            use3DSecure: true,
            cvv: values?.cvv,
            cardInfo: {
              cardHolderName,
              cardNumber: cardNumber?.replaceAll('-', ''),
              lastMonth,
              lastYear,
            },
          },
        },
        returnUrl: `${process.env.VITE_SITE_URL}/payment-result.html?paymentInstrument=NewCard${
          isDump ? '&PaymentReferenceType=preauth' : ''
        }`,
        totalAmount: paymentValue ? parseInt(paymentValue.replaceAll('.', ''), 10) : 0,
        customerInfo: { customerId: customerId?.toString() },
      },
      paymentReferenceType: 4,
      referenceId: fleetLoadBalanceId,
      vouId: 4,
    };
    return dispatch(processPayment(body));
  };

  const saveNewCardPayLater = async () => {
    const action = await saveNewCardWithParam(true);
    const values = await form.validateFields();
    if (processPayment.fulfilled.match(action)) {
      const data = action?.payload?.data;
      if (data?.result === 'Success') {
        await handleOrderFinish();
        return;
      }
      modalAction('payWithNewCard', false);
      setThreeDSecureContent(
        'data:text/html;charset=utf-8,' + encodeURIComponent(action?.payload?.data?.redirectForm),
      );
      modalAction('threeDSecureModalVisible', true);
      setSaveCardBody({ body: values, checked: true });
    }
  };

  const saveNewCard = async () => {
    modalAction('payWithNewCard', false);
    const values = await form.validateFields();
    try {
      const action = await saveNewCardWithParam(false);
      if (processPayment.fulfilled.match(action)) {
        const data = action?.payload?.data;
        if (data?.result === 'Success') {
          await handleOrderFinish();
          return;
        }
        setThreeDSecureContent(
          'data:text/html;charset=utf-8,' + encodeURIComponent(action?.payload?.data?.redirectForm),
        );
        modalAction('threeDSecureModalVisible', true);
        if (values.cardSaveChecked) {
          setSaveCardBody({ body: values, checked: true });
        }
      }
    } catch (e) {}
  };

  const handlePayment = useCallback(async () => {
    if (formVisible) {
      await saveNewCard();
    } else if (selectedStoredCard) {
      const body = {
        body: {
          currency: 'TRY',
          paymentInstrument: 'StoredCard',
          paymentInstrumentInfo: {
            storedCard: {
              processType: 'sales',
              use3DSecure: false,
              cardToken: selectedStoredCard,
            },
          },
          returnUrl: `${process.env.VITE_SITE_URL}/payment-result.html?paymentInstrument=StoredCard`,
          customerInfo: { customerId: customerId.toString() },
          totalAmount: paymentValue ? parseInt(paymentValue.replaceAll('.', ''), 10) : 0,
        },
        paymentReferenceType: 4,
        referenceId: fleetLoadBalanceId,
        vouId: 4,
      };
      /*const body = {
        body: {
          currency: 'TRY',
          paymentInstrument: 'NewCard',
          paymentInstrumentInfo: {
            newCard: {
              processType: 'sales',
              use3DSecure: true,
              cvv: values?.cvv,
              cardInfo: {
                cardHolderName: values?.cardHolderName,
                cardNumber: values?.cardNumber?.replaceAll('-', ''),
                lastMonth: values?.lastMonth,
                lastYear: values?.lastYear,
              },
            },
          },
          returnUrl: `${process.env.VITE_SITE_URL}/payment-result.html?paymentInstrument=NewCard`,
          totalAmount: paymentValue,
          customerInfo: { customerId: customerId?.toString() },
        },
        paymentReferenceType: 4,
        referenceId: fleetLoadBalanceId,
      };*/

      const action = await dispatch(processPayment(body));
      if (processPayment.fulfilled.match(action)) {
        const data = action?.payload?.data;
        if (data?.result === 'Success') {
          await handleOrderFinish(action);
        } else {
          setThreeDSecureContent(
            'data:text/html;charset=utf-8,' +
              encodeURIComponent(action?.payload?.data?.redirectForm),
          );
          modalAction('threeDSecureModalVisible', true);
        }
      }
    }
  }, [
    dispatch,
    form,
    formVisible,
    selectedStoredCard,
    selectedCustomer,
    saveNewCard,
    saveNewCardPayLater,
  ]);

  useEffect(() => {
    window.handlePayment = isVerifiedPayment;
    return () => {
      window.handlePayment = () => {};
    };
  }, [handlePayment]);

  const handleOrderFinish = useCallback(
    async (action) => {
      await finishOrder(action);
    },
    [fleetLoadBalanceId, dispatch],
  );

  const isVerifiedPayment = useCallback(async () => {
    document?.activeElement?.blur();
    if (afterMount) {
      if (formVisible) {
        modalAction('payWithNewCard', true);
        await form.validateFields();
      }
      if (!formVisible) {
        await paymentLater();
        return;
      }
    }
    if (payWithLinkinEmail) {
      await paymentLater();
      return;
    }
    if (formVisible) {
      await handlePayment();
      return;
    }
    await handlePayment();
  }, [
    afterMount,
    dispatch,
    form,
    formVisible,
    handleOrderFinish,
    handlePayment,
    payWithLinkinEmail,
  ]);

  const finishPaymentProcessHandlerFunc = useCallback(
    async (body) => {
      try {
        const action = await dispatch(finishPaymentProcess(body));
        if (finishPaymentProcess.fulfilled.match(action)) {
          if (action?.payload?.data?.result === 'Success') {
            /*const formData = await form.getFieldsValue();
            const cardBin = formData.cardNumber?.replaceAll('-', '')?.slice(0, 6) || '';
            const orderRes = await dispatch(
              createFleetLoadBalanceSuccess({
                data: {
                  id: fleetLoadBalanceId,

                  customerId: customerId,

                  mobilExpressMerchantProcessId:
                    action?.payload?.data?.processInfo?.merchantProcessId,

                  mobilExpressOrderId: action?.payload?.data?.paymentInfo?.orderId,

                  mobilExpressSystemTransId: action?.payload?.data?.paymentInfo?.systemTransId,

                  mobilExpressIsPayment: 0,

                  paymentType: 4,

                  paymentLater: false,

                  cardBin: cardBin,

                  pendingApproval: false,

                  sendMail: true,

                  orderStatus: 100,
                },
              }),
            );
            if (orderRes?.payload?.isSuccess) {
              setIsOrderFinishSuccess(true);

              modalAction('threeDSecureModalVisible', false);
              setTimeout(() => {
                setIsOrderSuccess(true);
              }, 500);
            }*/
          }
          if (saveCardBody.checked) {
            const body = {
              saveCardBody: {
                customerInfo: {
                  customerId: customerId?.toString(),
                },
                cardHolterName: saveCardBody?.body?.cardHolderName,
                cardNumber: saveCardBody?.body?.cardNumber?.replaceAll('-', ''),
                cardMonth: saveCardBody?.body?.lastMonth,
                cardYear: saveCardBody?.body?.lastYear,
                selectedVous: [
                  {
                    vouId: 1,
                    vouName: 'TICKET RESTAURANT',
                  },
                ],
              },
              creditCartVouMatchList: [
                {
                  customerId: customerId?.toString(),
                  vouId: 4,
                  provisionDay: 0,
                  type: 0,
                },
              ],
            };
            const newCardResponse = await dispatch(setCreditCardMatchVous(body));
            if (setCreditCardMatchVous.fulfilled.match(newCardResponse)) {
              const newCardToken = newCardResponse?.payload?.data?.cardToken;
              await dispatch(setSelectStoredCard(newCardToken));
              _selectedStoredCard = newCardToken;
              paymentOrderDueDate = true;
            }
          }
          if (formVisible) {
            if (payWhenBalanceActiveDate) {
              setPayWhenBalanceActiveDate(false);
              await paymentLater();
              return;
            }
          }
          await handleOrderFinish(action);
        } else {
          modalAction('threeDSecureModalVisible', false);
        }
      } catch (e) {
        console.error('e', e);
      }
    },
    [dispatch, form, formVisible, handleOrderFinish, saveCardBody?.body, saveCardBody.checked],
  );

  const iframeOnLoad = useCallback(
    (queryString) => {
      if (queryString) {
        const urlParams = new URLSearchParams(queryString);
        const paymentInstrument = urlParams.get('paymentInstrument');
        const orderId = urlParams.get('OrderId');
        const systemTransId = urlParams.get('SystemTransId');
        const Result = urlParams.get('Result');
        const totalAmount = urlParams.get('TotalAmount');
        const paymentReferenceType = urlParams.get('PaymentReferenceType');

        const isPreAuth = paymentReferenceType === 'preauth';

        if (Result === '3DFailed' || Result === '') {
          modalAction('threeDSecureModalVisible', false);
          errorDialog({
            title: <Text t="error" />,
            message: <Text t="mobilExpressError" />,
          });
        } else if (paymentInstrument && orderId && systemTransId) {
          const body = {
            paymentReferenceType: 4,
            referenceId: fleetLoadBalanceId,
            body: {
              orderId,
              merchantProcessId: 'IslemId33',
              systemTransId: systemTransId,
              paymentInstrument: paymentInstrument,
              paymentInstrumentInfo: {},
              totalAmount: +totalAmount,
            },
          };

          if (paymentInstrument === 'NewCard') {
            body.body.paymentInstrumentInfo = {
              newCard: {},
            };
          } else {
            body.body.paymentInstrumentInfo = {
              storedCard: { otp: '', cvv: '' },
            };
          }

          if (isPreAuth) {
            body.paymentReferenceType = 4;
            body.referenceId = fleetLoadBalanceId;
            body.vouId = 4;
            body.body.paymentInstrumentInfo = {
              newCard: {},
            };
          }
          (async () => {
            await finishPaymentProcessHandlerFunc(body);
          })();
        } else {
          modalAction('threeDSecureModalVisible', false);
        }
      }
    },
    [fleetLoadBalanceId, finishPaymentProcessHandlerFunc],
  );

  useEffect(() => {
    console.log('iframeOnLoad');
    window.finishPaymentProcessHandler = iframeOnLoad;
    window.modalAction = modalAction;
    return () => {
      window.finishPaymentProcessHandler = () => {};
      window.modalAction = () => {};
    };
  }, [iframeOnLoad]);

  function formatCurrency(value) {
    const formattedValue = new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 0,
    }).format(value);
    return formattedValue.replace('₺', '') + '₺';
  }

  return (
    <div
      className="vehicle-managemet-add-fleet-limit-summary"
      data-testid="vehicle-managemet-add-fleet-limit-summary"
    >
      <button
        style={{
          borderWidth: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'row',
          gap: 10,
          height: 30,
          fontWeight: '600',
          color: '#162056',
          backgroundColor: 'transparent',
        }}
        onClick={goBackPayment}
        data-testid="vehicle-managemet-add-fleet-limit-summary-back"
      >
        <CustomImage src={iconBack} />
        <Text t="turnBack" />
      </button>
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: 5,
        }}
      >
        <div
          style={{
            display: 'flex',
            fontSize: 14,
            color: '#3f4957',
            flexDirection: 'row',
            gap: 10,
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
          }}
        >
          <span>
            <Text t="limitAmountToBeAdded" />
          </span>
          <span style={{ fontWeight: 'bold' }}>
            {formatCurrency(paymentValue ? parseInt(paymentValue.replaceAll('.', ''), 10) : 0)}
          </span>
        </div>
        {/*<div
          style={{
            display: 'flex',
            fontSize: 14,
            color: '#3f4957',
            flexDirection: 'row',
            gap: 10,
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
          }}
        >
          <span>İskonto:</span>
          <span style={{ fontWeight: 'bold' }}>500,00 ₺</span>
        </div>*/}
        <div
          style={{
            display: 'flex',
            fontSize: 14,
            color: '#3f4957',
            flexDirection: 'row',
            gap: 10,
            alignItems: 'center',
            justifyContent: 'flex-end',
            marginTop: 10,
          }}
          data-testid="vehicle-managemet-add-fleet-limit-summary-total"
        >
          <span style={{ fontWeight: 'bold' }}>
            <Text t="totalAmountYouWillPay" />
          </span>
          <span style={{ fontWeight: 'bold', fontSize: 26 }}>
            {formatCurrency(paymentValue ? parseInt(paymentValue.replaceAll('.', ''), 10) : 0)}
          </span>
        </div>

        <div
          className="footer-content"
          style={{ marginTop: 20, display: 'flex', width: 'auto', flexDirection: 'column' }}
        >
          <Button
            data-testid="vehicle-managemet-add-fleet-limit-summary-button"
            onClick={isVerifiedPayment}
            className="btn-orange"
          >
            <span>
              <Text t="confirmPayment" />
            </span>
          </Button>
        </div>
      </div>

      {modals.threeDSecureModalVisible && (
        <CustomModal
          width={500}
          maskClosable={false}
          footer={false}
          title={threeDSecurity}
          visible={true}
          onCancel={() => modalAction('threeDSecureModalVisible', false)}
          closeIcon={<CustomImage src={modalClose} />}
        >
          <embed src={threeDSecureContent} width="100%" height="400" />
        </CustomModal>
      )}

      {modals.payWithNewCard && (
        <PayWithNewCard
          setModalVisible={(value) => modalAction('payWithNewCard', value)}
          saveAction={saveNewCardPayLater}
          paymentLater={paymentLater}
          setPaymentOrderDueDate={() => null}
          formVisible={formVisible}
          form={form}
        />
      )}
    </div>
  );
};

OrderSummary.propTypes = {
  form: PropTypes.any,
  formVisible: PropTypes.any,
  paymentValue: PropTypes.any,
  setIsOrderSuccess: PropTypes.any,
  goBackPayment: PropTypes.func,
};

export default OrderSummary;
